import { FC, ReactNode } from 'react';
import NavigationItem from './NavigationItem';
import styles from './Navigation.module.css';
import { NavigationItemResponse } from './types';

export interface NavigationListProps {
  items: NavigationItemResponse[];
  expanded: boolean;
  id?: string;
  callback?: (item: NavigationItemResponse) => void;
  currentItem?: NavigationItemResponse;
}

const NavigationList: FC<NavigationListProps> = ({
  items,
  expanded,
  id,
  callback,
  currentItem,
}: NavigationListProps): ReactNode => {
  return (
    <ul
      className={`${styles.navlist} ${expanded ? '' : styles.hidden} `}
      id={id}
    >
      {items.map((item, index) => (
        <NavigationItem
          key={index}
          item={item}
          callback={callback}
          currentItem={currentItem}
        />
      ))}
    </ul>
  );
};

export default NavigationList;
